import { Injectable, inject } from '@angular/core';
import { Sort } from '@angular/material/sort';
import { Store } from '@ngrx/store';
import { DataleanBaseApiService, DataleanPagedResult, PaginationInfo, Parts, SimpleObject, SortInfo } from 'addiction-components';
import { Observable, forkJoin, tap } from 'rxjs';
import { HeaderLocaleService } from 'src/app/components';
import { ContestActions } from 'src/app/core/state/app.actions';
import { Contest } from 'src/app/shared/models';
import { environment } from 'src/environments/environment';

@Injectable({ providedIn: 'root' })
export class ContestService {
	private headerSrv = inject(HeaderLocaleService);
	private baseApi = inject(DataleanBaseApiService);

	getContests(options: {
		parts?: Parts[];
		locale?: string;
		pagination?: PaginationInfo;
		sort?: SortInfo;
		filters?: { uuids?: string[]; query?: string };
	}) {
		const { filters, parts, locale, pagination, sort } = options;

		const params: SimpleObject = {
			locale: locale ?? this.headerSrv.getActiveLocale(),
			active: true,
		};

		// TODO: generalizzare questa logica in una funzione reutilizzabile
		if (filters?.query) {
			params['q'] = filters.query;
			params['searchFields'] = ['name', 'description']; // parametrizzare i campi di ricerca??
		}

		if (filters?.uuids) params['uuid'] = filters.uuids.join(',');

		return this.baseApi.getManyPaged<Contest>(environment.contestUrl, parts ?? [], {
			pagination,
			sort,
			additionalParams: params,
		});
	}

	deleteContest(uuid: string) {
		return this.baseApi.deleteEntity(environment.contestUrl, { uuid });
	}

	fetchContests(pages: number[], sort?: Sort, locale?: string, gridSearch?: string | null): Observable<DataleanPagedResult<Contest>[]> {
		const obs: Observable<DataleanPagedResult<Contest>>[] = [];
		const params: {
			sortBy?: string;
			q?: string;
			searchFields?: string;
			locale?: string;
			active: boolean;
		} = {
			...(locale || this.headerSrv.getActiveLocale() ? { locale: locale ?? this.headerSrv.getActiveLocale() } : {}),
			active: true,
			sortBy: 'updateDate#desc',
		};

		//SORT
		if (sort) params.sortBy = `${sort.active}#${sort.direction}`;
		if (gridSearch) {
			params.q = gridSearch;
			params.searchFields = 'name,description';
		}

		for (const page of pages) {
			const pagination: PaginationInfo = new PaginationInfo(environment.pageSize, page);

			obs.push(
				this.baseApi.getManyPaged<Contest>(environment.contestUrl, [Parts.CREATED_BY], {
					pagination,
					additionalParams: params,
				})
			);
		}
		return forkJoin(obs);
	}
}
